export default __webpack_public_path__ + "static/media/box_bomile.6784022a.svg";